module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tasks":"Tasks","notes":"Notes"},"et":{"tasks":"Tasks","notes":"Notes"},"ru":{"tasks":"Tasks","notes":"Notes"}}')
  delete Component.options._Ctor
}
